import { GetPolywizzParams, SubmitPolywizzParams } from '../../interfaces/Insurance';
import { APICore, INSURANCE_URL } from './apiCore';

const api = new APICore();

const createInsurance = (clientId: string, creationReason?: string, confirmSpouseInsurance?: boolean) => {
    return api.create(`${INSURANCE_URL}/insurance`, { clientId, creationReason, confirmSpouseInsurance });
};

const editInsurance = (insuranceId: string, body: any) => {
    const relativeUrl = `/insurance/${insuranceId}`;
    return api.update(`${INSURANCE_URL}${relativeUrl}`, body);
};

const deleteInsurance = (insuranceId: string) => {
    const relativeUrl = `/insurance/${insuranceId}`;
    return api.delete(`${INSURANCE_URL}${relativeUrl}`);
};

const getInsuranceStatuses = () => {
    return api.get(`${INSURANCE_URL}/insurance/statuses`);
};

const submitPolywizz = (params: SubmitPolywizzParams) => {
    return api.create(`${INSURANCE_URL}/polywizz/submit`, params);
};

const getPolywizz = (params: GetPolywizzParams) => {
    const url = `${INSURANCE_URL}/polywizz`;
    return api.get(url, params);
};

const getPolywizzByInsuranceId = (insuranceId: string) => {
    const url = `${INSURANCE_URL}/polywizz/insurance`;
    return api.get(url, { insuranceId });
};

const resubmitPolywizzPolicies = (params: SubmitPolywizzParams) => {
    return api.create(`${INSURANCE_URL}/polywizz/resubmit-policies`, params);
};

const getInsuranceStatusTrackers = (params: { insuranceId?: string; clientId?: string }) => {
    const url = `${INSURANCE_URL}/insurance/status-trackers`;
    return api.get(url, params);
};

const getPolywizzStatusTrackers = (params: { polywizzId?: string; clientId?: string }) => {
    const url = `${INSURANCE_URL}/polywizz/status-trackers`;
    return api.get(url, params);
};

export {
    getInsuranceStatuses,
    getPolywizzByInsuranceId,
    createInsurance,
    editInsurance,
    deleteInsurance,
    submitPolywizz,
    resubmitPolywizzPolicies,
    getPolywizz,
    getInsuranceStatusTrackers,
    getPolywizzStatusTrackers,
};
